import { useState } from 'react';
import { Button, Flex, Typography } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { AuditLogChange } from 'components/common/audit-logs/components/audit-log-change';
import { AuditMessage } from 'components/common/audit-logs/components/audit-message';
import { auditLogServiceFactory } from 'components/common/audit-logs/services';
import styles from './audit-log-item.module.scss';
import type { IAuditLogItemProps } from './types.ts';

const { Text } = Typography;

export const AuditLogItem: React.FC<IAuditLogItemProps> = (props) => {
  const { auditLog, currentEntity, referenceData, isGrouped, hasSameNextCorrelation } = props;
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  const auditLogService = auditLogServiceFactory(auditLog, currentEntity, referenceData);

  const itemClassName = classNames(styles.item, {
    [styles.groupedItem]: isGrouped,
    [styles.groupEndItem]: isGrouped && !hasSameNextCorrelation,
  });

  return (
    <Flex className={itemClassName} gap={4} vertical>
      <Flex align='center' justify='space-between'>
        <Text type='secondary'>{auditLogService.date}</Text>
        <Flex align='center' gap={16}>
          {auditLogService.hasDetails ? (
            <Button className={styles.detailsButton} type='link' onClick={() => setIsDetailsOpen((isOpen) => !isOpen)}>
              Details {isDetailsOpen ? <UpOutlined /> : <DownOutlined />}
            </Button>
          ) : null}
          <Text type='secondary'>#{auditLog.id}</Text>
        </Flex>
      </Flex>
      <Flex className={styles.titleRow} align='center'>
        <Text>
          <AuditMessage segments={auditLogService.messageSegments} />
        </Text>
      </Flex>
      {isDetailsOpen ? (
        <div className={styles.details}>
          {auditLogService.changeGroups.map((group, index) => (
            <div key={group.name ?? index}>
              {group.name ? <div className={styles.changeGroupTitle}>{group.name}</div> : null}
              <div className={classNames(styles.changes, { [styles.groupedChanges]: group.name })}>
                {group.changes.map((change) => (
                  <AuditLogChange key={change.fieldName} change={change} />
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </Flex>
  );
};
